import React, { useEffect, useState } from "react";
import styled from "styled-components";
import Grid from "@material-ui/core/Grid";
import { connect } from "react-redux";
import { compose } from "redux";
import { InputText, ButtonIcon } from "@loanbossinc/component-library";
import { getDealName } from "store/state/deal";

export const Wrapper = styled.div`
  margin: 16px 0;
`;

const campaignMap = {
  "Refi Cash Out": "Refi Proceeds",
  "Refi Breakeven": "Breakeven Spread",
  "Prepayment": "Prepayment"
};

export const DealSelector = ({ onSelect, campaign, dealNames, getDealName }) => {
  const [inputValue, setInputValue] = useState("");

  const searchDeal = () => {
    getDealName({ dealId: inputValue, subKey: inputValue });
  };

  useEffect(() => {
    if (dealNames && dealNames[inputValue]) {
      onSelect({
        name: dealNames[inputValue].name,
        type: campaignMap[campaign]
      });
    }
  }, [dealNames]);

  return (
    <Wrapper>
      <Grid container alignItems="center">
        <InputText
          variant="outlined"
          placeholder="Deal ID"
          label={"Deal ID"}
          name="dealId"
          type="text"
          onChange={e => setInputValue(e.target.value)}
          style={{ width: "220px", marginRight: "5px" }}
          value={inputValue}
        />
        <ButtonIcon iconName="arrow_forward" onClick={searchDeal} />
      </Grid>
    </Wrapper>
  );
};

// export default DealSelector

const mapStateToProps = ({ deal }) => ({
  dealNames: deal.dealNames
});

const mapDispatchToProps = {
  getDealName
};

export default compose(
  connect(mapStateToProps, mapDispatchToProps)
)(DealSelector);
